import { useQuery } from "@apollo/client";
import { getPriorities } from "api/queries/RCA/PriorityAPI";
import { IPriority, IPriorityEntity } from "./PriorityEntityInterfaces";
import { useEffect, useState } from "react";

export const PriorityEntity: IPriorityEntity = {
    GetPriorities: () => {
        const { loading, error, data } = useQuery(getPriorities);
        const [priorities, setPriorities] = useState<IPriority[]>([]);

        useEffect(() => {
            if (data) {
                setPriorities(data.priority);
            }
        }, [data]);

        return {
            loading,
            priorities,
            apolloQueryError: error,
        };
    },
};
